import { RESET_SELECTED_FUND } from '../../types/quickbuy';
import * as type from '../../types/trans';
import { CART_TOTAL_AMOUNT } from '../../types/trans';

let init = {
    totalAmountData: null,
    cartCountData: null
}

export default function authDetails(state = init, action) {
    switch (action.type) {
        case type.CART_TOTAL_AMOUNT:
            return {
                ...state,
                totalAmountData: action.payload,
            }
        case RESET_SELECTED_FUND:
            return {
                ...state,
                totalAmountData: null
            }
        default:
            return state
    }
}